import { render, staticRenderFns } from "./TabCitaFirma.vue?vue&type=template&id=6a16845f&scoped=true"
import script from "./TabCitaFirma.vue?vue&type=script&lang=js"
export * from "./TabCitaFirma.vue?vue&type=script&lang=js"
import style0 from "./TabCitaFirma.vue?vue&type=style&index=0&id=6a16845f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16845f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a16845f')) {
      api.createRecord('6a16845f', component.options)
    } else {
      api.reload('6a16845f', component.options)
    }
    module.hot.accept("./TabCitaFirma.vue?vue&type=template&id=6a16845f&scoped=true", function () {
      api.rerender('6a16845f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabCitaFirma.vue"
export default component.exports